import { useContext } from 'react';
import EvmNetworkContext from 'contexts/EvmNetworkContext';

const useEvmNetwork = () => useContext(EvmNetworkContext);

export default useEvmNetwork;
